export interface Tariffs {
    id: number;
    srNo?:number
    type?: any;
    name?: string;
    companyName?:string
    plantName?:string
    year?:string
}

export interface TariffTypeAndCompany {
    id?: number;
    srNo?:number
    name?: string;
}

export interface PlantsTariff {
    id: number;
    srNo?:number
    tariff_company_id?: number;
    tariff_company?: string;
    tariff_type_id?:number
    tariff_type?:string
    plant_id?:number
    plant?:string
    plant_ids?:number
    year?:number
    rates?:any
}